export function useNavbarHeight() {

  //Return height of navbar
  const navbar = document.body.getElementsByClassName('mantine-Navbar-root')[0]

  return navbar ? navbar.clientHeight : 0
}